import React from "react";
import styled from "styled-components";
import {
  GoogleLoginButton,
  FacebookLoginButton
} from "react-social-login-buttons";
import { firebaseConnect } from "react-redux-firebase";
import { compose } from "redux";
import { connect } from "react-redux";

import logo from "./images/logo.png";

const Section = styled.section`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  height: 256px;
`;

const Name = styled.h1`
  font-size: 4em;
  margin: 0.25em;
`;

const Tagline = styled.p`
  margin: 0 0 3em;
`;

export const LoginPage = ({ firebase, auth }) => (
  <Section>
    <Logo alt="Logotyp" src={logo} />
    <Name>Hot tip!</Name>
    <Tagline>
      Bevakning av insynspersoners<br />handel med aktier.
    </Tagline>
    <GoogleLoginButton
      style={{ margin: ".5em 0", width: "250px", height: "3em" }}
      onClick={() => firebase.login({ provider: "google", type: "redirect" })}
    >
      Logga in med Google
    </GoogleLoginButton>
    <FacebookLoginButton
      style={{ margin: ".5em 0", width: "250px", height: "3em" }}
      onClick={() => firebase.login({ provider: "facebook", type: "redirect" })}
      disabled
    >
      Logga in med Facebook
    </FacebookLoginButton>
  </Section>
);

export default compose(
  firebaseConnect(), // withFirebase can also be used
  connect(({ firebase: { auth } }) => ({ auth }))
)(LoginPage);



// WEBPACK FOOTER //
// ./src/Login.js